import { useMemo } from 'react';
import { object, date } from 'yup';
import { useTranslation } from 'react-i18next';

import { mergeInitialValues } from '@utils/formik';
import { CorporateHealthQuote } from '@models/CorporateHealthQuote';

import { FormValues } from './type';

export const useInitialValues = (corporateHealthQuote?: CorporateHealthQuote | null) => {
  const initialValues: FormValues = {
    activationDate: '',
  };

  return useMemo(() => {
    if (!corporateHealthQuote) return;
    return mergeInitialValues(initialValues, corporateHealthQuote);
  }, [corporateHealthQuote]);
};

export const useValidationSchema = () => {
  const { t } = useTranslation();

  return object({
    activationDate: date().required(t('validation:required')),
  });
};
